var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoClock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icons/24x24/ico_clock") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Consumer_tablet",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "107_protection_extras",
    transform: "translate(-985.000000, -567.000000)",
    fill: "#191919",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "shape",
    transform: "translate(983.000000, 565.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.0004,12.0001 C20.0004,7.58174729 16.4184778,4.0001 12.0004,4.0001 C7.58168475,4.0001 4.0004,7.58138475 4.0004,12.0001 C4.0004,16.4181778 7.58204729,20.0001 12.0004,20.0001 C16.4181153,20.0001 20.0004,16.4178153 20.0004,12.0001 Z M22.0004,12.0001 C22.0004,17.5223847 17.5226847,22.0001 12.0004,22.0001 C6.47744343,22.0001 2.0004,17.522713 2.0004,12.0001 C2.0004,6.47681525 6.47711525,2.0001 12.0004,2.0001 C17.523013,2.0001 22.0004,6.47714343 22.0004,12.0001 Z M15.7075068,14.2929932 L14.2932932,15.7072068 L11.0004,12.4143136 L11.0004,6.0001 L13.0004,6.0001 L13.0004,11.5858864 L15.7075068,14.2929932 Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoClock);
export default __webpack_public_path__ + "static/media/ico_clock.31be2dd902386d326f2805f6114add4f.svg";
export { ForwardRef as ReactComponent };